import {DEMAND_RESPONSE, performanceTarget, pointOfMeasurement, programTypes} from '../domain/constants';
import {Program} from "../domain/cloud-topology";
import moment from "moment-timezone"


export class ResourceService {
  static buildUrl(urlParts: any[]): string {
    return (urlParts.length > 0) ? urlParts.join('/') : null;
  }

  buildUrl(urlParts: any[]): string {
    return (urlParts.length > 0) ? urlParts.join('/') : null;
  }

  static cleanProgramText(key: string, fieldType: string): string {
    let fieldOptions = [];
    if (fieldType === 'programTypes') {
      fieldOptions = programTypes;
    } else if (fieldType === 'performanceTarget') {
      fieldOptions = performanceTarget;
    } else if (fieldType == 'pointOfMeasurement') {
      fieldOptions = pointOfMeasurement;
    }

    for (const option of fieldOptions) {
      if (option.key === key) {
        return option.value;
      }
    }

    return '';
  }

  static convertTime12To24(time12h) {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }

    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  }

  static getDefaultSnackBarConfig(): any {
    return {
      duration: 3000,
      horizontalPosition: "right",
      verticalPosition: "bottom"
    }
  }

  static canCreateDispatch(program: Program): boolean {
    return program.programType === DEMAND_RESPONSE;
  }

  static convertBootstrapDate(formElement): string {
    const date = moment(formElement['dateTimeForm']['date']).format().split('T')[0];
    const minute = formElement['dateTimeForm']['startTime'].getMinutes() < 10 ? ('0' +  formElement['dateTimeForm']['startTime'].getMinutes()) :  formElement['dateTimeForm']['startTime'].getMinutes();
    const hour = formElement['dateTimeForm']['startTime'].getHours() < 10 ? ('0' +  formElement['dateTimeForm']['startTime'].getHours()) :  formElement['dateTimeForm']['startTime'].getHours();

    const startTime = hour + ':' + minute;
    return `${date}T${startTime}`;
  }
}
